import React from 'react';
import "./Unauthorized.css";

export const Unauthorized = () => (
    <div>
      <div className="unauthorized_text">You do not have access to the Condo Go application's Active Directory group!</div>
    </div>
  )